/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_D2tInputs */

const en_mk_sol_lembaga_d2t = /** @type {(inputs: Mk_Sol_Lembaga_D2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field notes come in as issues`)
};

const id_mk_sol_lembaga_d2t = /** @type {(inputs: Mk_Sol_Lembaga_D2tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catatan kegiatan masuk sebagai issue`)
};

/**
* | output |
* | --- |
* | "Field notes come in as issues" |
*
* @param {Mk_Sol_Lembaga_D2tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_d2t = /** @type {((inputs?: Mk_Sol_Lembaga_D2tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_D2tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_d2t(inputs)
	return en_mk_sol_lembaga_d2t(inputs)
});